var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 69,
    rx: 8.5,
    stroke: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3332 49.25V46.0833C42.3332 44.4036 41.6659 42.7927 40.4782 41.605C39.2904 40.4173 37.6795 39.75 35.9998 39.75H26.4998C24.8201 39.75 23.2092 40.4173 22.0215 41.605C20.8338 42.7927 20.1665 44.4036 20.1665 46.0833V49.25",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2498 33.4167C34.7476 33.4167 37.5832 30.5811 37.5832 27.0833C37.5832 23.5855 34.7476 20.75 31.2498 20.75C27.752 20.75 24.9165 23.5855 24.9165 27.0833C24.9165 30.5811 27.752 33.4167 31.2498 33.4167Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8335 49.2502V46.0836C51.8324 44.6803 51.3654 43.3171 50.5057 42.2081C49.6459 41.099 48.4422 40.3069 47.0835 39.9561",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3335 20.9561C43.6958 21.3049 44.9033 22.0972 45.7656 23.208C46.6279 24.3189 47.0959 25.6852 47.0959 27.0915C47.0959 28.4977 46.6279 29.864 45.7656 30.9749C44.9033 32.0858 43.6958 32.8781 42.3335 33.2269",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesImage);
export default __webpack_public_path__ + "static/media/EmployeesImage.3b4446ad6337ced37d25395bc9dd9dd0.svg";
export { ForwardRef as ReactComponent };